import { CommonModule } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

// Components
import { ButtonComponent } from '../../../../../../shared/_components/button/button.component';
import { CheckboxComponent } from '../../../../../../shared/_components/checkbox/checkbox.component';
import { TextAreaComponent } from '../../../../../../shared/_components/text-area/text-area.component';
import { FlowMediaUploadStep } from '../../flows/flow-media-upload/step/flow-media-upload-step.component';
import { PostPreviewComponent } from '../../post-preview/post-preview.component';

// Models
import { IntegrationProvider } from '../../../../../models/integration-providers.model';

@Component({
  selector: 'pp-step-integration-instagram',
  templateUrl: './step-integration-instagram.component.html',
  imports: [CommonModule, ButtonComponent, CheckboxComponent, PostPreviewComponent, TextAreaComponent],
})
export class StepIntegrationInstagramComponent extends FlowMediaUploadStep implements AfterViewInit {

  // Component handler (!IMPORTANT - Must match step identifier for this flow)
  identifier = 'mediaUploadFlowStepIntegrationInstagram';

  constructor() {
    super();

    this.form = new FormGroup({
      instaPostTitle: new FormControl<string>(''),
      instaPostDescription: new FormControl<string>('', Validators.required),
      instaIncludeOddrLink: new FormControl<boolean>(true),
    });
  }

  ngAfterViewInit(): void {
    // Instagram has no separate title field and the title is optional, so we
    // intentionally do NOT pre-fill it from the signing title (unlike the other
    // providers). Leaving it blank keeps the caption clean by default.
    this.form.get('instaPostTitle')?.setValue('');
    this.form.get('instaPostDescription')?.setValue('');
  }

  oddrLinkSelected(include: boolean): void {
    this.form.get('instaIncludeOddrLink')?.setValue(include);
  }

  submitAndGoToNextStep(): void {
    this.mediaUploadService.storeSelectedIntegrationPayload(this.constructAndStorePayloadForProvider()).subscribe({
      next: () => this.goToNextStep(),
    });
  }

  private constructAndStorePayloadForProvider(): any {
    const payload = {
      title: this.form.get('instaPostTitle')?.value as string,
      description: this.form.get('instaPostDescription')?.value as string,
      includeOddrLink: this.form.get('instaIncludeOddrLink')?.value as boolean,
    };
    return this.cleanIntegrationPayload(IntegrationProvider.Instagram, payload);
  }
}
